import type { DashboardDefinition } from "@/analytics/core/types";

export const exploreDashboard: DashboardDefinition = {
  id: "explore",
  label: "Explore",
  route: "/explore",
  departmentScoped: true,
};

export const gridDashboards: DashboardDefinition[] = [
  { id: "grid-sales", label: "Sales Grid", route: "/grid/sales" },
  { id: "grid-sdr", label: "SDR Grid", route: "/grid/sdr" },
];

export function listAnalyticsDashboards(): DashboardDefinition[] {
  return [exploreDashboard];
}

export function exploreRouteForDepartment(departmentId: string): string {
  return `/explore/${departmentId}`;
}
